import { Routes } from '@angular/router';
import { EditLocationComponent } from './edit-location.component';
import { CanDeactivateGuard } from '../../core/can-deactivate.guard';
import { routerSegments } from '@consts/routes';
import { LocationDetailsComponent } from './location-details/location-details.component';
import { LocationSpeakersComponent } from './location-speakers/location-speakers.component';
import {
  LocationSpeakersAddComponent
} from './location-speakers/location-speakers-add/location-speakers-add.component';
import { LocationConfigurationComponent } from './location-configuration/location-configuration.component';
import { RemoteIOsRoutingModule } from './remote-ios/remote-ios-routing.module';

export const EditLocationRoutes: Routes = [
  {
    path: ':locationId',
    component: EditLocationComponent,
    canDeactivate: [CanDeactivateGuard],
    children: [
      {
        path: routerSegments.details,
        loadComponent: () => LocationDetailsComponent,
        data: {
          breadcrumb: 'LOCATION_EDIT.MENU.DETAILS',
        }
      },
      {
        path: routerSegments.speakers,
        component: LocationSpeakersComponent,
        data: {
          breadcrumb: 'LOCATION_EDIT.MENU.SPEAKERS',
        }
      },
      {
        path: routerSegments.addSpeaker,
        component: LocationSpeakersAddComponent,
      },
      {
        path: `${routerSegments.editSpeaker}/:speakerId`,
        component: LocationSpeakersAddComponent,
      },
      {
        path: routerSegments.configuration,
        component: LocationConfigurationComponent,
        data: {
          breadcrumb: 'LOCATION_EDIT.MENU.CONFIGURATION',
        }
      },
      {
        path: routerSegments.appleTV,
        loadChildren: () => import('./apple-tv/apple-tv-routing.module').then(m => m.AppleTvRoutingModule),
      },
      {
        path: routerSegments.externalStorage,
        loadChildren: () => import('./external-storage/external-storage-routing.module').then(m => m.ExternalStorageRoutingModule),
      },
      {
        path: routerSegments.sensors,
        loadChildren: () => import('./sensors/sensors-routing.module').then(m => m.SensorsRoutingModule),
      },
      {
        path: routerSegments.remoteIOs,
        loadChildren: () => import('./remote-ios/remote-ios-routing.module').then(m => m.RemoteIOsRoutingModule),
      },
      {
        path: '',
        redirectTo: routerSegments.details,
        pathMatch: 'full',
      },
    ],
  },
];
